import React from 'react';
import { IBlockData } from '../../../typings';
import { BasicType } from '../../../constants';
import { merge } from 'lodash';
import { BlockRenderer } from '../../../components';
import { createBlock, t } from '../../../utils';

export type ITemplate = IBlockData<
    {},
    {
        idx?: string | null;
    }
>;

export const Template = createBlock<ITemplate>({
    get name() {
        return t('Template');
    },
    type: BasicType.TEMPLATE,
    create: (payload: any) => {
        const defaultData: ITemplate = {
            type: BasicType.TEMPLATE,
            data: {
                value: {
                    idx: '',
                },
            },
            attributes: {},
            children: [],
        };
        return merge(defaultData, payload);
    },
    validParentType: [],
    render(params: any) {
        const { data } = params;
        return (
            <>
                {`
          ${data.children.map((child: IBlockData<any, any>) => (
                    <BlockRenderer {...params} data={child} />
                ))}
        `}
            </>
        );
    },
});
